import { render, staticRenderFns } from "./listVendas.vue?vue&type=template&id=0c56e7b4"
import script from "./listVendas.ts?vue&type=script&lang=js&external"
export * from "./listVendas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c56e7b4')) {
      api.createRecord('0c56e7b4', component.options)
    } else {
      api.reload('0c56e7b4', component.options)
    }
    module.hot.accept("./listVendas.vue?vue&type=template&id=0c56e7b4", function () {
      api.rerender('0c56e7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/cliente/listVendas.vue"
export default component.exports